<template>
	<v-container class="special-search">
		<v-layout row wrap>
			<v-flex offset-xs2 xs8>			
				<v-btn 
					class="v-btn--text-transform-none ml-0"
					outline
					color="primary"
					@click="$emit('update:mode', 'simple')"
					v-if="this.$vuetify.breakpoint.name !== 'xs'"
				>
          Простой поиск
				</v-btn>
				<v-btn 
					class="v-btn--text-transform-none ml-0"
					outline
					color="primary"
					@click="$emit('update:mode', 'extended')"
					v-if="this.$vuetify.breakpoint.name !== 'xs'"
				>
					Расширенный поиск
				</v-btn>
        <v-btn 
					class="v-btn--text-transform-none ml-0" 
					color="primary" 
					style="cursor: default" 
					:ripple="false" 
					depressed 
					:input-value="true"
				>
					Спецпоиск
				</v-btn>
				<a @click="clear()"><u>Очистить</u></a>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-if="searchForVacancy">
			<v-flex xs2>
				<h3>Для вакансии: </h3>
			</v-flex>
			<v-flex xs8>
				<v-chip
					v-model="searchForVacancy"
					close
					label
					outline
					@click="openVacancy(vacancy)"
				>   
					<span style="cursor: pointer">
						{{ vacancy.name }}
					</span>
				</v-chip>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs2>
				<h3>ФИО: </h3>
			</v-flex>
			<v-flex xs2 class="mr-3">
				<v-text-field
					solo
					v-model.trim="model.search_settings[0].text"
					counter
					maxlength="30"
					placeholder="Фамилия"
				/>
			</v-flex>
			<v-flex xs2 class="mr-3">
				<v-text-field
					solo
					v-model.trim="model.search_settings[1].text"
					counter
					maxlength="30"
					placeholder="Имя"
				/>
			</v-flex>
			<v-flex xs2>
				<v-text-field
					solo
					v-model.trim="model.search_settings[2].text"
					counter
					maxlength="30"
					placeholder="Отчество"
				/>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs2>
				<h3>Дата рождения: </h3>
			</v-flex>
			<v-flex xs1 class="mr-3">
				<v-text-field
					solo
					v-model.trim="model.birth_day"
					counter
					maxlength="2"
					placeholder="День"
				/>
			</v-flex>
      <v-flex xs1 class="mr-3">
				<v-text-field
					solo
					v-model.trim="model.birth_month"
					counter
					maxlength="2"
					placeholder="Месяц"
				/>
			</v-flex>
      <v-flex xs1>
				<v-text-field
					solo
					v-model.trim="model.birth_year"
					counter
					maxlength="4"
					placeholder="Год"
				/>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs2>
				<h3>Контакт: </h3>
			</v-flex>
			<v-flex xs4 class="mr-3">
				<field-phone-number
					v-if="model.contact_type.id === 'mobile'"
					v-model="model.search_settings[3].text" 
					:mask="currentPhoneHelper.mask"
					:mask-checker="currentPhoneHelper.maskChecker"
					:symbols-to-remove-from-mask="currentPhoneHelper.symbolsToRemove"
					:placeholder="currentPhoneHelper.placeholder"
				/>
				<v-text-field
					v-else
					solo
					v-model.trim="model.search_settings[3].text"
					counter
					maxlength="50"
					placeholder="example@gmail.com"
				/>
			</v-flex>
			<v-flex xs2>
				<v-select
					v-model="model.contact_type"
					:items="contact_types"
					:menu-props="{ offsetY : true }"
					return-object
					item-text="name"
					solo
					class="contact-type"
				/>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import phoneHelper from '../../../../../app/components/helpers/phone-helper';
import FieldPhoneNumber from './field-phone-number';

export default {
	name: 'app-special-search',

	components: {
		FieldPhoneNumber
	},

	props: {
		mode: {
			type: String
		},
		model: {
			type: Object
		},
	},

	data() {
		return {
			currentPhoneHelper: phoneHelper,
			vacancy: {},
			searchForVacancy: false,
			contact_types: [
				{ id: 'mobile', name: 'Телефон' },
				{ id: 'email', name: 'E-mail' }
			]
		}
	},

	watch: {
		'model.contact_type': {
			handler() {
				this.model.search_settings[3].text = '';
			},
			deep: true
		},
		searchForVacancy() {
			if (!this.searchForVacancy) {
				this.vacancy = {};
				window.localStorage.removeItem('vacancy_id');
				this.model.vacancy_id = null;
			}
		}
	},

	async mounted() {
		if (this.$context.user.isResearcher || this.$context.user.isAdmin) {
			if (this.model.vacancy_id) {
				this.vacancy = (await this.$http.get(`/api/v1/recruiting/vacancy/${this.model.vacancy_id}`)).data;
				this.searchForVacancy = true;
			}
		} else {
			this.searchForVacancy = false;
		}
	},

	methods: {
		clear() {
			this.model.search_settings = [
				{
					text: '',
					search_type: { id: '0efa102f-03ff-4a1d-aa94-348a258259e3', code: 'all_words', name: 'Все слова' },
					experience_period: { id: '5198423c-fe7a-490a-96b9-3201ac57a8a0', code: 'all', name: 'За все время опыта' },
					search_areas: [
						{ id: '332ca9bb-f192-4625-acb2-01916fb15d18', code: 'lastname', name: 'В фамилии', parent_id: null }
					]
				},
				{
					text: '',
					search_type: { id: '0efa102f-03ff-4a1d-aa94-348a258259e3', code: 'all_words', name: 'Все слова' },
					experience_period: { id: '5198423c-fe7a-490a-96b9-3201ac57a8a0', code: 'all', name: 'За все время опыта' },
					search_areas: [
						{ id: '241af6e7-116f-4d96-a825-976a58d2d961', code: 'firstname', name: 'В имени', parent_id: null }
					]
				},
				{
					text: '',
					search_type: { id: '0efa102f-03ff-4a1d-aa94-348a258259e3', code: 'all_words', name: 'Все слова' },
					experience_period: { id: '5198423c-fe7a-490a-96b9-3201ac57a8a0', code: 'all', name: 'За все время опыта' },
					search_areas: [
						{ id: 'c45c54d0-12f5-4539-8146-a0bf07da833b', code: 'middlename', name: 'В отчестве', parent_id: null }
					]
        },
        {
					text: '',
					search_type: { id: '0efa102f-03ff-4a1d-aa94-348a258259e3', code: 'all_words', name: 'Все слова' },
          experience_period: { id: '5198423c-fe7a-490a-96b9-3201ac57a8a0', code: 'all', name: 'За все время опыта' },
					search_areas: [
						{ id: '8caf3c5b-d0ff-46dd-ae27-5a9c9bfc863a', code: 'contact', name: 'В контактах', parent_id: null }
					]
				}
			];
			this.model.birth_day = null;
			this.model.birth_month = null;
			this.model.birth_year = null;
			this.model.contact_type = { id: 'mobile', name: 'Телефон' };
			this.model.search_period = { id: '4892c204-611a-49de-88c3-4962dcd8fbb5', code: 'all_time', name: 'За весь период' };
			this.model.currency = {};
			this.model.move_type = { id: '48f3409f-8199-44a7-8070-81cda64c3d20', code: 'live_here', name: 'Живут в указанном регионе' };
			// this.model.scopes = [];
			this.model.regions = [];
			// this.model.tags = [];
			this.model.countries = [];
			this.model.work_permissions = [];
			this.model.driving_categories = [];
			// this.model.institutions = [];
			this.model.languages = [];
			this.model.experience_types = [];
			this.model.sex = { id: 'afdbfbc2-9bae-4597-8129-5adf5aa18333', code: 'Любой', name: 'Любой', short_name: 'Любой', state: '', ts_create: null };
			this.model.required = [];
			this.model.bought_resumes = true;
			this.model.operators_search = true;
			this.model.hide_viewed_resumes = false;
			this.model.sort_order = 'change_date';
			this.model.start_salary = null;
			this.model.end_salary = null;
			this.model.start_age = null;
			this.model.end_age = null;
			this.model.only_with_age = false;
			this.model.only_with_salary = false;
			this.model.employment_types = [];
			this.model.schedule_types = [];
			this.model.has_auto = false;
		},
		openVacancy(item) {
			window.open(`/#/vacancies/list/${item.id}`, '_blank');
		}
	}
}
</script>

<style lang="less">
.special-search {
	margin: 0px 8px;
	padding-left: 0px;

	.v-chip {
		margin-left: 0;
		height: 36px !important;
	}
	
	.v-btn-toggle{
		.v-btn {
			box-shadow: none !important;
			border-color: #a6a6a6;
			border-width: 1px;
			border-style: solid;
			color:black;
			opacity: unset;
		}
	}
	> .layout {
		padding-bottom: 4px;
	}
	>.flex {
		margin-bottom: 6px;
	}
	.flex.xs3 {
		min-width: 50px;
	}
	.checkbox-group {
		margin-top: 2px;
		margin-left: -2px;
		.v-input__slot {
			margin-bottom: 4px;
		}
		.v-input--selection-controls {
			margin-top: 0px;
			padding-top: 0px;
		}
	}
	.v-input--radio-group {
		margin-top: 0px;
		padding-top: 0px;
		margin-left: -2px;
		.v-messages {
			// display: none;
		}
	}

	.contact-type {
		width: 150px;
	}
}
</style>